/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetHierarchyUsage1Request {
    rootTenantId: string;
    startTime?: string;
    endTime?: string;
}

export interface GetTenantUsageRequest {
    tenantId: string;
    startTime?: string;
    endTime?: string;
    featureId?: string;
}

/**
 * UsageAdminApi - interface
 * 
 * @export
 * @interface UsageAdminApiInterface
 */
export interface UsageAdminApiInterface {
    /**
     * 
     * @summary Get hierarchy usage (admin)
     * @param {string} rootTenantId Root tenant ID
     * @param {string} [startTime] Start of period (ISO-8601)
     * @param {string} [endTime] End of period (ISO-8601)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageAdminApiInterface
     */
    getHierarchyUsage1Raw(requestParameters: GetHierarchyUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get hierarchy usage (admin)
     */
    getHierarchyUsage1(requestParameters: GetHierarchyUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Get usage for tenant (admin)
     * @param {string} tenantId Tenant ID
     * @param {string} [startTime] Start of period (ISO-8601)
     * @param {string} [endTime] End of period (ISO-8601)
     * @param {string} [featureId] Optional feature ID filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsageAdminApiInterface
     */
    getTenantUsageRaw(requestParameters: GetTenantUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get usage for tenant (admin)
     */
    getTenantUsage(requestParameters: GetTenantUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class UsageAdminApi extends runtime.BaseAPI implements UsageAdminApiInterface {

    /**
     * Get hierarchy usage (admin)
     */
    async getHierarchyUsage1Raw(requestParameters: GetHierarchyUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['rootTenantId'] == null) {
            throw new runtime.RequiredError(
                'rootTenantId',
                'Required parameter "rootTenantId" was null or undefined when calling getHierarchyUsage1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/usage/hierarchy/{rootTenantId}`;
        urlPath = urlPath.replace(`{${"rootTenantId"}}`, encodeURIComponent(String(requestParameters['rootTenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get hierarchy usage (admin)
     */
    async getHierarchyUsage1(requestParameters: GetHierarchyUsage1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getHierarchyUsage1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get usage for tenant (admin)
     */
    async getTenantUsageRaw(requestParameters: GetTenantUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantUsage().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['featureId'] != null) {
            queryParameters['featureId'] = requestParameters['featureId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/admin/usage/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get usage for tenant (admin)
     */
    async getTenantUsage(requestParameters: GetTenantUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTenantUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
